import React, { useContext } from 'react';
import { ChatStateContext } from '../contexts/chatStateContext';
import { SocialContext } from '../contexts/socialContext';
import { StateContext } from '../contexts/stateContext';
import { DesignThemeSync } from './DesignThemeSync';
import { Faq } from './Faq';
import { WithVersion } from './UiKit/VersionToggler';




export const Layout = React.memo((props) => {
  const {
    children
  } = { ...props };


  const context = { ...useContext(SocialContext), ...useContext(StateContext) };
  const chatState = useContext(ChatStateContext);


  return (
    <>
      <DesignThemeSync />
      {/* <WithVersion>
        <div className="x_beta inact"><div>experimental</div></div>
      </WithVersion> */}

              {children}


      {Boolean(context.me) 
        && !chatState.unauthorized 
        && !context.state.citySearchActive
        && context.state.supportShown && <Faq />}

    </>
  )
})